import { PlanProgressTransitionReportsSettingState } from '../../redux/ui/planProgressTransitionReportsSetting';
import { DataPlanProgressTransitionData } from '../dataPlanProgressTransition';

/**
 * rowsからisShowRowがfalseの行を除去する
 */
export const filterShowRows = (
  rows: DataPlanProgressTransitionData['rows'],
  isShowRow: PlanProgressTransitionReportsSettingState['isShowRow'],
  isForecastAiEnabled?: boolean
) => {
  const removeHiddenRowsDates = [
    ...(isShowRow.previousYearSameMonth ? [] : ['前年同月', '前年同月比']),
  ];

  if (!isShowRow.forecast) {
    // 着地見込のチェックがfalseの場合、すべての着地見込関連行を除外
    removeHiddenRowsDates.push(
      '着地見込',
      '着地見込差',
      '着地見込(AI)',
      '着地見込差(AI)'
    );
  } else if (isForecastAiEnabled !== undefined) {
    // 着地見込のチェックがtrueの場合、isForecastAiEnabledに応じて切り替え
    if (isForecastAiEnabled) {
      // AI切替がONの場合、「着地見込」「着地見込差」を除外
      removeHiddenRowsDates.push('着地見込', '着地見込差');
    } else {
      // AI切替がOFFの場合、「着地見込(AI)」「着地見込差(AI)」を除外
      removeHiddenRowsDates.push('着地見込(AI)', '着地見込差(AI)');
    }
  }

  return rows.filter((row) => !removeHiddenRowsDates.includes(row.date));
};
